import { RouterView } from "vue-router";
import { CategoryRouting } from "./category/category.routing";
import { BrandRouting } from "./brand/brand.routing";
import { LibraryRouting } from "./library/library.routing";
import { RepoRouting } from "./repo/repo.routing";
import { UnitRouting } from "./unit/unit.routing";
import { AccessManagementRouting } from "./access-management/access-management.routing";

export const MaterialBaseRouting = {
  path: "/materialBase",
  name: "material-base",
  redirect: "/material/category/list",
  component: RouterView,
  meta: { title: "材料管理", icon: "cailiao" },
  children: [
    ...CategoryRouting,
    ...BrandRouting,
    ...LibraryRouting,
    ...RepoRouting,
    ...UnitRouting,
    ...AccessManagementRouting,
  ],
};
